cockpitApp.directive('locationOptions', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/location/options',
    controllerAs: 'locationOptionsCtrl',
    controller: 'locationOptionsController'
  };
});
